export default __webpack_public_path__ + "static/media/lime beanie.870db5b9.png";